import Api from 'services/api';
import apiURLBuilder from 'core/apiURLBuilder';

const sendEmailOTP = async data => {
    const requestParams = {
        header: {},
        query: data,
    };

    try {
        const response = await Api.post(apiURLBuilder.getURL('sendEmailOtp'), requestParams);
        if (response.ok) return response.body;
    } catch (error) {
        return error.body;
    }
};

const validateOTP = async data => {
    const requestParams = {
        header: {},
        query: data,
    };

    try {
        const response = await Api.post(apiURLBuilder.getURL('validateEmailOtp'), requestParams);
        if (response.ok) return response.body;
    } catch (error) {
        return error.body;
    }
};

export { validateOTP, sendEmailOTP };
